export default "__VITE_ASSET__rtL_OrkX__"